export const MockCOTData = [
    // USD
    { currency: "USD", date: "2025-08-02", long: 105000, short: 95000 },
    { currency: "USD", date: "2025-07-26", long: 103000, short: 97000 },

    // EUR
    { currency: "EUR", date: "2025-08-02", long: 88000, short: 94000 },
    { currency: "EUR", date: "2025-07-26", long: 86000, short: 95000 },

    // GBP
    { currency: "GBP", date: "2025-08-02", long: 72000, short: 81000 },
    { currency: "GBP", date: "2025-07-26", long: 70000, short: 83000 },

    // JPY
    { currency: "JPY", date: "2025-08-02", long: 65000, short: 78000 },
    { currency: "JPY", date: "2025-07-26", long: 64000, short: 80000 },

    // NZD
    { currency: "NZD", date: "2025-08-02", long: 31000, short: 29000 },
    { currency: "NZD", date: "2025-07-26", long: 30000, short: 30500 },

    // CHF
    { currency: "CHF", date: "2025-08-02", long: 45000, short: 52000 },
    { currency: "CHF", date: "2025-07-26", long: 44000, short: 53000 },

    // CAD
    { currency: "CAD", date: "2025-08-02", long: 56000, short: 60000 },
    { currency: "CAD", date: "2025-07-26", long: 54000, short: 61000 },

    // AUD
    { currency: "AUD", date: "2025-08-02", long: 47000, short: 49000 },
    { currency: "AUD", date: "2025-07-26", long: 46000, short: 50000 },

    // Gold (XAU)
    { currency: "XAU", date: "2025-08-02", long: 280000, short: 250000 },
    { currency: "XAU", date: "2025-07-26", long: 275000, short: 260000 },
];

export default MockCOTData;
